export const getSelectedMod = (productMods, modID) => {
  return productMods.flatMap(modGroup => modGroup.items).find(mod => mod.id === modID);
};
